export { default as Browsers } from './Browsers';
export { default as Hero } from './Hero';
export { default as Reviews } from './Reviews';
export { default as Integrations } from './Integrations';
export { default as Partners } from './Partners';
export { default as Solutions } from './Solutions';
export { default as Subscription } from './Subscription';
export { default as VideoSection } from './VideoSection';
